import { PathSlopeType } from "../mid-path/interface";
export const DEFAULT_ROAD_SETTING = {
    commonSetting: {
        path: {
            leftWidth: 2.5,
            rightWidth: 2.5,
            roadSlopeType: PathSlopeType.CROSS,
            interpolationPitch: 5,
            leftSlope: 50,
            rightSlope: 50,
            color: "#FFFFFF",
            transparency: 1,
        },
        cutSetting: {
            generateShelf: true,
            left: {
                moundSlope: 1,
                slopeHeight: 5,
                shelfSlope: 100,
                shelfWidth: 1.5,
            },
            right: {
                moundSlope: 1,
                slopeHeight: 5,
                shelfSlope: 100,
                shelfWidth: 1.5,
            },
            color: "#FFA500",
            transparency: 1,
        },
        embarkmentSetting: {
            generateShelf: true,
            left: {
                moundSlope: 1,
                slopeHeight: 5,
                shelfSlope: 100,
                shelfWidth: 1.5,
            },
            right: {
                moundSlope: 1,
                slopeHeight: 5,
                shelfSlope: 100,
                shelfWidth: 1.5,
            },
            color: "#008000",
            transparency: 1,
        },
    },
};
export const DEFAULT_ROAD = `{
  "roadId": "824ced90-9549-4aa4-85a5-9ee558a57f32",
  "controlPointData": [
    { "position": [-3982058.3587338547, 3331343.1060711034, 3692506.4695820366], "bendType": "curve" },
    { "position": [-3982080.251214937, 3331324.7008229434, 3692502.334078372], "bendType": "curve" },
    { "position": [-3982096.753520295, 3331323.3771240674, 3692482.0374214654], "bendType": "curve" },
    { "position": [-3982112.239103176, 3331326.582169516, 3692466.2012576354], "bendType": "curve" },
    { "position": [-3982089.4355285424, 3331353.648262026, 3692463.1927407673], "bendType": "curve" }
  ],
  "roadSettings": {
    "commonSettings": {
      "leftWidth": 2.5,
      "rightWidth": 2.5,
      "leftSlope": 50,
      "rightSlope": 50,
      "interpolationPitch": 5,
      "surfaceColor": "#DDDDDD",
      "segmentSettings": []
    },
    "cutSettings": {
      "roadHeight": 5,
      "moundSlope": 1,
      "shelfWidth": 1.5,
      "shelfSlope": 100,
      "bLeftRightSettings": false,
      "generateShelf": true,
      "color": "#FFA500",
      "transparency": 1,
      "leftSlopeHeight": 5,
      "leftMoundSlope": 1,
      "leftShelfWidth": 1.5,
      "leftShelfSlope": 100,
      "rightSlopeHeight": 5,
      "rightMoundSlope": 1,
      "rightShelfWidth": 1.5,
      "rightShelfSlope": 100,
      "outline": true,
      "outlineColor": { "red": 0, "green": 0, "blue": 0, "alpha": 1 },
      "controlLineSettings": {
        "width": 1,
        "color": { "red": 0.5294117647058824, "green": 0.807843137254902, "blue": 0.9215686274509803, "alpha": 0.5 },
        "outlineColor": { "red": 1, "green": 0, "blue": 0, "alpha": 1 },
        "outlineWidth": 3,
        "clampToGround": false,
        "epsilonGapBetWeenMeshAndPolyline": 0.1
      },
      "centerLineSettings": { "width": 3, "clampToGround": false, "color": { "red": 0, "green": 0, "blue": 0, "alpha": 1 } },
      "polyLineSettings": {
        "width": 9,
        "color": { "red": 0.5294117647058824, "green": 0.807843137254902, "blue": 0.9215686274509803, "alpha": 0.5 },
        "outlineColor": { "red": 0, "green": 0, "blue": 1, "alpha": 1 },
        "outlineWidth": 3,
        "clampToGround": false,
        "epsilonGapBetWeenMeshAndPolyline": 0.1
      }
    },
    "embarkmentSettings": {
      "roadHeight": 5,
      "moundSlope": 1.5,
      "shelfWidth": 1.5,
      "shelfSlope": 100,
      "bLeftRightSettings": true,
      "generateShelf": true,
      "color": "#008000",
      "transparency": 1,
      "leftSlopeHeight": 5,
      "leftMoundSlope": 1.5,
      "leftShelfWidth": 1.5,
      "leftShelfSlope": 100,
      "rightSlopeHeight": 5,
      "rightMoundSlope": 1.5,
      "rightShelfWidth": 1.5,
      "rightShelfSlope": 100,
      "outline": true,
      "outlineColor": { "red": 0, "green": 0, "blue": 0, "alpha": 1 },
      "controlLineSettings": {
        "width": 1,
        "color": { "red": 0.5294117647058824, "green": 0.807843137254902, "blue": 0.9215686274509803, "alpha": 0.5 },
        "outlineColor": { "red": 1, "green": 0, "blue": 0, "alpha": 1 },
        "outlineWidth": 3,
        "clampToGround": false,
        "epsilonGapBetWeenMeshAndPolyline": 0.1
      },
      "centerLineSettings": { "width": 3, "clampToGround": false, "color": { "red": 0, "green": 0, "blue": 0, "alpha": 1 } },
      "polyLineSettings": {
        "width": 9,
        "color": { "red": 0.5294117647058824, "green": 0.807843137254902, "blue": 0.9215686274509803, "alpha": 0.5 },
        "outlineColor": { "red": 0, "green": 0, "blue": 1, "alpha": 1 },
        "outlineWidth": 3,
        "clampToGround": false,
        "epsilonGapBetWeenMeshAndPolyline": 0.1
      }
    }
  },
  "asscoatedRoads": []
}`;
export const DEFAULT_TERRIAN_PROFILE_VIEW_STEP_SIZE = 0.5;
export const DEFAULT_TERRIAN_SECTION_VIEW_STEP_SIZE = 0.5;
export const DEFAULT_ROAD_LABEL_COLOR = "#F283E5";
//# sourceMappingURL=defaults.js.map